import { InputAdornment, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsEditMod, selectIsUndoModal, selectStandard } from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { validDecimalAndLength } from '../../ModificationsUtils';

export const BonusAmount = ({ readOnly }: { readOnly?: boolean }) => {
  const { control, getValues, setValue, clearErrors, setError } = useFormContext();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isUndoModal = useSelector(selectIsUndoModal);
  const bonusAmount = 'bonusAmount';
  const bonusAmountWatch: number = useWatch({ name: bonusAmount });
  const isModEdit = useSelector(selectIsEditMod);
  const standard = useSelector(selectStandard);
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });

  useEffect(() => {
    if (getValues(bonusAmount)) {
      clearErrors(bonusAmount);
    } else {
      setError(bonusAmount, {});
    }
    if (isUndoModal) {
      dispatch(placementModsAction.setIsUndoModal(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUndoModal]);

  return (
    <Controller
      control={control}
      name={bonusAmount}
      rules={{
        required: true,
      }}
      render={({ field: { onChange, value, ...rest } }) => (
        <TextField
          variant="filled"
          id="bonusAmount"
          fullWidth
          color="primary"
          autoComplete="off"
          label={t('placement.placementMods.bonusAmount')}
          InputProps={{
            readOnly: readOnly !== undefined ? readOnly : (standard ? standard : !isModEdit),
            style: {
              pointerEvents: readOnly !== undefined ? (readOnly ? 'none' : 'auto') : (standard || !isModEdit ? 'none' : 'auto'),
            },
            startAdornment: <>{value && <InputAdornment position="start">{t('currency.dollar')}</InputAdornment>}</>,
          }}
          InputLabelProps={{
            shrink: bonusAmountWatch ? true : false,
          }}
          onChange={e => {
            if (validDecimalAndLength(e.target.value, { numberLength: 6, decimalLength: 2 })) {
              const validInput = e.target.value.replace(/^\./, '0.');
              setValue(bonusAmount, validInput);
              onChange(validInput);
              if (validInput) clearErrors(bonusAmount);
            }
          }}
          disabled={isSaveModApiCalling}
          value={getValues(bonusAmount) ?? ''}
          {...rest}
        />
      )}
    />
  );
};
